import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Fetches all products from the backend using the centralized API call utility.
 *
 * @returns {Promise<Object[]>} - Array of product objects.
 * @throws Will throw an error if the request fails.
 * 
 * @author Susovan Mishra
 */
const fetchProducts = async () => {
  return await apiCall(AUTH_ROUTES.PRODUCTS_API_ENDPOINT, {
    method: "GET",
  });
};

export default fetchProducts;
